import mobileMenu from "./modules/MobileMenu";
import QueryLink from "./modules/QueryLink";
import formControl from "./modules/FormControl";
import dropdownController from "./modules/DropDownController";
import ProductMenuSwitcher from "./modules/ProductMenuSwitcher";

/* -------------------------------------------------------------------------- */
/*                                  Elements                                  */
/* -------------------------------------------------------------------------- */
const dropdownSalesSwitcherEl = document.querySelector(
  ".dropdown .js-sales-switcher"
);
const mobileMenuSalesSwitcherEl = document.querySelector(
  ".mobile-menu .js-sales-switcher"
);

/* -------------------------------------------------------------------------- */
/*                             Register Dropdowns                             */
/* -------------------------------------------------------------------------- */
dropdownController.registerDropdown("sales");
dropdownController.registerDropdown("search");

/* -------------------------------------------------------------------------- */
/*                             Init Menu Switcher                             */
/* -------------------------------------------------------------------------- */

new ProductMenuSwitcher({ menuEl: dropdownSalesSwitcherEl }).init();
new ProductMenuSwitcher({
  menuEl: mobileMenuSalesSwitcherEl,
  mobile: true,
}).init();

/* -------------------------------------------------------------------------- */
/*                              Init Mobile Menu                              */
/* -------------------------------------------------------------------------- */
mobileMenu({
  selector: ".mobile-menu",
  block: "mobile-menu",
  toggleActiveClass: "header__hamburger--open",
});

/* -------------------------------------------------------------------------- */
/*                              Init Form Control                             */
/* -------------------------------------------------------------------------- */
formControl(".volvo-form-control");

/* -------------------------------------------------------------------------- */
/*                         Init Header Scroll Listener                        */
/* -------------------------------------------------------------------------- */

const header = document.querySelector(".header--follow");

window.addEventListener("scroll", () => {
  // window scroll listener
  if (!window.scrollY) {
    header.classList.remove("header--scrolling");
  } else {
    header.classList.add("header--scrolling");
  }
});

/* -------------------------------------------------------------------------- */
/*                              Init Query Links                              */
/* -------------------------------------------------------------------------- */
const queryLinks = new QueryLink(".query-link");
